import HeroSlider from "../components/HeroSlider"
import WholesaleCTA from "../components/WholesaleCTA"
import MOQBanner from "../components/MOQBanner"
import TrendingProducts from "../components/TrendingProducts"
import BestSelling from "../components/BestSelling"
import CategorySection from "../components/CategorySection"
import PopularCategories from "../components/PopularCategories"
import TrustSection from "../components/TrustSection"
import WholesaleBenefits from "../components/WholesaleBenefits"

import WooProducts from "../components/WooProducts"

function Home({ search }){

return(

<div>

<HeroSlider/>

<WholesaleCTA/>

<MOQBanner/>

{/*<TrendingProducts/>

<BestSelling/>*/}

<CategorySection/>

{/*<PopularCategories/>*/}

<TrustSection/>

<WholesaleBenefits/>

{/*<WooProducts search={search}/>*/}

</div>

)

}

export default Home
